import { SET_ADRESS_LIST } from "./types/kundenAdresse-types";
import axios from "axios";

export function setAdressList(adressList) {
  return {
    type: SET_ADRESS_LIST,
    payload: adressList
  };
}

export const sendAdresse = (axiosObject, data) => async dispatch => {
  if (axiosObject && !data && axiosObject.json) {
    data = axiosObject.json;
  }
  await axios[axiosObject.request.type](axiosObject.url, { ...data });
  dispatch({ type: SET_ADRESS_LIST, payload: data.listKundenAdressen });
};
